import {DELETE_NOTIFICATION_START} from "../../types";

export const delete_notification = (payload) => ({
    type: DELETE_NOTIFICATION_START,
    payload,
});
